import XianWu from "../Assets/XianWu.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img className="card-img-style" src={XianWu} alt="judge picture"></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Xian Wu</h2>
        <p className="card-sub-name-style">
          Director and Principal Researcher at Tencent Jarvis Lab
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          className="close-button"
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />
            <h2>Xian Wu</h2>
            <h3>Director and Principal Researcher at Tencent Jarvis Lab</h3>

            <br />
            <p>
              Dr. Xian Wu is the Director and Principal Researcher at Tencent
              Jarvis Lab. His primary research interests encompass natural
              language understanding, deep learning, and large-scale medical
              models.
              <br />
              <br />
              Under his leadership, his team has developed a series of medical
              AI solutions, including the Tencent Medical Large Language Model.
              These technologies are applied in various clinical scenarios, such
              as critical patient Q&A, medical record generation, and discharge
              summaries. Currently, these products are deployed in over 1,900
              hospitals and serve approximately 2.5 million users per month.
              <br />
              <br />
              Dr. Wu has published over 100 papers in top-tier international
              journals and conferences, including Nature Biomedical Engineering,
              Nature Computational Science, npj Digital Health, T-PAMI, NeurIPS,
              ACL, CVPR, and MICCAI. His work has garnered over 9,500 citations,
              and he holds nearly 50 patents in the U.S. and China. He is also
              recognized as World's Top 2% Scientists in 2025.
              <br />
              <br />
              His accolades include the First Prize of the Huaxia Medical
              Science and Technology Award, a first-place ranking in the
              international MSCOCO competition, and second place in the ICDM
              Knowledge Graph Evaluation.
              <br />
              <br />
              Prior to joining Tencent, Dr. Wu worked at IBM Research and
              Microsoft's AI and Research Division. He holds a Ph.D. in Computer
              Science from Shanghai Jiao Tong University.
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
